var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 59,
    viewBox: "0 0 71 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 9.58407H0L1.58654 0H69.3039L71 9.58407Z",
    fill: "#5B836D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 13.447V58.1201H25.8492V43.1944C25.8492 39.2922 28.8448 36.1284 32.5394 36.1284H44.8088V58.1201H53.6554C61.2046 58.1201 67.3251 51.6559 67.3251 43.6827V13.447H3.33301ZM54.6349 26.7202H16.0232C15.1532 26.7202 14.4454 25.8546 14.4454 24.7877C14.4454 23.7207 15.151 22.8551 16.0232 22.8551H54.6349C55.5049 22.8551 56.2127 23.7207 56.2127 24.7877C56.2127 25.8546 55.5071 26.7202 54.6349 26.7202Z",
    fill: "#5B836D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.26312aed148215be967ca16e093e98a7.svg";
export { ForwardRef as ReactComponent };